<template>
  <div id="loan-details" class="tw-p-4 tw-max-w-md tw-mx-auto">
    <div class="loan-summary-grid tw-mt-4 tw-mb-6">
      <div class="summary-cell">
        <p class="label">Credit Amount</p>
        <p class="value">
          {{ formatAmountToCurrency(loanDetails.amount, currency) }}
        </p>
      </div>

      <div class="summary-cell">
        <p class="label">Reason for Loan</p>
        <p class="value tw-text-blue-700">{{ loanDetails.reason }}</p>
      </div>

      <div class="summary-cell">
        <p class="label">Duration</p>
        <p class="value">{{ loanDetails.duration }}</p>
      </div>

      <div class="summary-cell">
        <p class="label">Interest</p>
        <p class="value">{{ loanDetails.interest_rate * 100 }}%</p>
      </div>

      <div class="summary-cell">
        <p class="label">Repayment Amount</p>
        <p class="value">
          {{ formatAmountToCurrency(loanDetails.repayment_amount, currency) }}
        </p>
      </div>

      <div class="summary-cell">
        <p class="label">Repayment Date</p>
        <p class="value">
          {{ formatDate(loanDetails.repayment_date) }}
        </p>
      </div>
    </div>

    <div class="tw-mb-6">
      <h3 class="tw-font-medium tw-text-lg tw-mb-4">Collateral</h3>

      <div>
        <div
          v-for="(value, key) in loanDetails.collaterals"
          :key="key"
          class="tw-flex tw-justify-between tw-items-center tw-py-2"
        >
          <p class="tw-font-medium tw-text-sm tw-text-[#1A2139]">{{ value.token?.symbol }}</p>
          <p class="tw-font-medium tw-bg-[#F0F4FD] tw-px-[10px] tw-py-[5px]">
            {{ value?.quantity.toFixed(2) }} shares
          </p>
        </div>
        <div
          v-if="Object.keys(loanDetails.collaterals).length === 0"
          class="tw-text-gray-500 tw-text-center tw-py-2"
        >
          No collateral information available
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { ref, computed, reactive, watch } from "vue";
import { useStore } from "vuex";

export default {
  name: "LoanDetailsComponent",

  props: {
    loanDetails: {
      type: Object,
      required: true,
    },
  },

  setup(props, { emit }) {
    const loanData = reactive({ ...props.loanDetails });
    const currency = ref("NGN");

    const loanDetails = computed(() => {
      return {
        amount: loanData.amount || 0,
        reason: loanData.reason || "N/A",
        duration: loanData.duration || "N/A",
        interest_rate: loanData.interest_rate || 0,
        repayment_amount: loanData.repayment_amount || 0,
        repayment_date:
          loanData.repayment_date || new Date().toISOString().split("T")[0],
        collaterals: loanData.collaterals || {},
      };
    });

    const store = useStore();

    const formatAmountToCurrency = (amount, currencyCode) => {
      if (currencyCode === "NGN") {
        return `₦${Number(amount).toLocaleString("en-NG")}`;
      }
      return `${currencyCode} ${Number(amount).toLocaleString()}`;
    };

    const formatDate = (dateString) => {
      const date = new Date(dateString);
      const options = { year: "numeric", month: "short", day: "numeric" };
      return date.toLocaleDateString("en-US", options);
    };

    watch(
      () => props.loanDetails,
      (newValue) => {
        Object.assign(loanData, newValue);
      },
      { deep: true }
    );

    return {
      loanDetails,
      currency,
      formatAmountToCurrency,
      formatDate,
    };
  },
};
</script>

<style scoped>
.loan-summary-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1px;
  background-color: #e5edff;
  border: 1px solid #e5edff;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.summary-cell {
  background-color: white;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.label {
  color: #4c5b90;
  margin-bottom: 0.5rem;
}

.value {
  color: #000;
  font-weight: 500;
}

@media (max-width: 640px) {
  .loan-summary-grid {
    grid-template-columns: 1fr;
  }
}
</style>